import DeleteTypeModal from './delete-type-modal';

export default DeleteTypeModal;
